export const LogoMark = ({ size = 28, className = "" }) => (
  <svg width={Math.round(size * 1.44)} height={size} viewBox="7 15 50 34.7" className={className} aria-hidden="true">
    <defs><clipPath id="edm-a"><circle cx="24" cy="32" r="16" /></clipPath></defs>
    <circle cx="24" cy="32" r="16" fill="var(--sage)" />
    <circle cx="40" cy="32" r="16" fill="var(--terra)" />
    <circle cx="40" cy="32" r="16" fill="var(--forest)" clipPath="url(#edm-a)" />
  </svg>
);

export const Logo = ({ className = "", size = 24 }) => (
  <span className={`inline-flex items-center gap-2 font-display whitespace-nowrap ${className}`}>
    <LogoMark size={size} /> En Dos Mundos
  </span>
);
